



























import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import Context from "@/mixins/context";

// Enums
import { DataModules } from "@/store/modules/data";
import { IState } from "@/store";
import { ITableConfig } from "@/models/tables";
import { Sorters } from "@/data/table";
import { IClient } from "@/models/clients";

@Component({
  computed: {
    ...mapState({
      params(state: IState, getters) {
        return getters[`data/${this.dataModule}/params`](this.clientId);
      }
    })
  }
})
export default class ClientsAddressesList extends Mixins(
  FilteringSortingTableStore,
  Context
) {
  // Props
  @Prop({ required: true })
  public clientId!: IClient["id"];
  @Prop({ default: false })
  public isStaged!: boolean;
  // Getters
  public params!: object;
  // Data
  public dataModule: string = DataModules.CLIENTS_ADDRESSES;
  public defaults: ITableConfig = {
    page: 1,
    limit: 0,
    sort: {
      field: "default,created_at",
      direction: Sorters.DESCENDING
    },
    filters: []
  };
  // Lifecycle methods
  public created() {
    if (
      this.$userCan("list_client_addresses") &&
      this.$userCan("list_countries")
    ) {
      this.dataPayloadSettings = { id: this.clientId };
      this.getData();
    } else {
      this.loading = false;
    }
  }

  // Methods
  public refreshList() {
    return this.getData({ ignoreStored: true });
  }
}
